import React, { Component } from 'react'

import get from 'lodash/get'
import min from 'lodash/min'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Tooltip } from 'react-tippy'
import { bindActionCreators } from 'redux'

import selectors from '../../../../../store/shared/selectors'
import { capitalize } from '../../../../../utils/string'
import * as skillsInfoDuck from '../../skillsInfoDuck'

import RankingBars from './components/RankingBars'
import withSkillDescription from '../../../../../utils/graphql/hocs/withSkillDescription'
import sendFullStoryEvent from '../../../../../utils/analyticsHelpers/sendFullStoryEvent'
import fullstory from '../../../../../utils/constants/fullstory'

const skillsPerPage = 20

class Skills extends Component {
  static propTypes = {
    currentRequestSkill: PropTypes.string,
    getSkillInfo: PropTypes.func,
    isMobile: PropTypes.bool,
    isRequestingSkillInfo: PropTypes.bool,
    searchTerm: PropTypes.string,
    skillDescription: PropTypes.string,
    skillInfoError: PropTypes.string,
    skills: PropTypes.array,
    skillsInfo: PropTypes.object,
  }

  constructor(props) {
    super(props)

    this.state = {
      skillData: [],
      expand: [],
      pageCount: 0,
      selectedSkill: null,
      skillDescriptionModalShown: false,
    }
  }

  componentWillMount() {
    const { skills } = this.props
    const skillData = skills && skills.slice(0, skillsPerPage)
    const pageCount = Math.ceil(skills.length / skillsPerPage)

    this.setState({
      skillData,
      pageCount,
    })
  }

  componentDidMount() {
    sendFullStoryEvent(fullstory.eventNames.filterResultsBySkills)
  }

  render() {
    const { skillData } = this.state
    const { searchTerm, isMobile } = this.props
    const minSalary = min(skillData.map(skill => get(skill, 'associatedSalary')))
    const skillMultiplier = minSalary > 95 ? 10 : 2

    this.setSkillDescriptionModal = setting =>
      this.setState({ skillDescriptionModalShown: setting })

    this.showSkillInfo = skillName => {
      const { selectedSkillName } = this.state
      if (selectedSkillName === skillName) {
        this.setSkillDescriptionModal(true)
        return
      } else {
        this.setState(
          {
            selectedSkillName: skillName,
            skillDescriptionModalShown: true,
          },
          this.getSkillDescription,
        )
      }
    }

    this.getSkillDescription = async () => {
      const { selectedSkillName } = this.state
      this.props.getSkillDescription({ skill: selectedSkillName })
      this.setState({ skillDescriptionModalShown: true })
    }

    return (
      <div>
        <div className="card shadow">
          <div>
            <div style={{ marginRight: 20 }}>
              <h4 className="text-center mt-3 mb-0">
                Top Skills{' '}
                {searchTerm
                  ? `for ${capitalize(
                      searchTerm && searchTerm.length > 30
                        ? `${searchTerm.slice(0, 30)}...`
                        : searchTerm,
                    )}`
                  : ''}
              </h4>
              <h6 className="text-center mb-2">hover for info</h6>
            </div>
            <div className="card-body">
              <div className="row mb-3">
                <div
                  className={
                    isMobile
                      ? 'light-gray offset-md-4 col text-center'
                      : 'offset-md-4 col text-center'
                  }
                >
                  <Tooltip
                    position="top"
                    title="The most frequently occurring skills in this population."
                  >
                    <i className="fal fa-fire mr-1" style={{ color: '#FF9551' }} />
                    Volume
                  </Tooltip>
                </div>
                {!isMobile && (
                  <div className="col text-center">
                    <Tooltip
                      position="top"
                      title="How significant these skills are to this group, compared against the general population."
                    >
                      <i className="fal fa-chart-network mr-1" style={{ color: '#99c4ee' }} />
                      Relevance
                    </Tooltip>
                  </div>
                )}
                <div className={isMobile ? 'light-gray col text-center' : 'col text-center'}>
                  <Tooltip
                    position="top"
                    title="The skills most likely to align with higher salary outcomes."
                  >
                    <i className="fa fa-dollar-sign mr-1" style={{ color: '#68CEB7' }} />
                    Salary
                  </Tooltip>
                </div>
              </div>
              {skillData.map((skill, index) => (
                <RankingBars
                  key={`${skill.key}-${index}`}
                  name={skill.key}
                  popularity={skill.doc_count}
                  relevance={skill.score}
                  salary={
                    get(skill, 'associatedSalary') -
                    (100 - get(skill, 'associatedSalary')) * skillMultiplier
                  }
                  showSkillInfo={this.showSkillInfo}
                  isMobile={isMobile}
                  setSkillDescriptionModal={this.setSkillDescriptionModal}
                  skillDescription={this.props.skillDescription}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  currentRequestSkill: state.skillsInfo && state.skillsInfo.currentSkill,
  isRequestingSkillInfo: selectors.getIsPerformingRequest(state, 'skillsInfo'),
  skillsInfo: state.skillsInfo && state.skillsInfo.skillsInfo,
  skillInfoError: state.skillsInfo && state.skillsInfo.error,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getSkillInfo: skillsInfoDuck.getSkillInfo,
    },
    dispatch,
  )

export default connect(mapStateToProps, mapDispatchToProps)(withSkillDescription(Skills))



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/components/Skills.js